import { modalActions } from '../../helpers/constants';

export const showModal = modalType => {

  return {
    type: modalActions.SHOW_MODAL,
    payload: modalType
  };

}

export const hideModal = () => ({
  type: modalActions.HIDE_MODAL
});